/* eslint-disable @typescript-eslint/no-explicit-any */
// Loads the official TradingView "Advanced Real-Time Chart" widget script (tv.js)
// exactly once and resolves with the global `TradingView` namespace. This is the
// FREE embed — no charting-library license or vendored bundle required. Unlike the
// simple iframe embed, the `new TradingView.widget(...)` constructor accepts an
// `overrides` object, which is what lets us recolor candles/background/grid to
// match the app theme. See https://www.tradingview.com/widget-docs/widgets/charts/advanced-chart/
const TV_SRC = "https://s3.tradingview.com/tv.js";

declare global {
  interface Window {
    TradingView?: any;
  }
}

let cached: Promise<any> | null = null;

export function loadTradingView(): Promise<any> {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.reject(new Error("no DOM"));
  }
  if (window.TradingView) return Promise.resolve(window.TradingView);
  if (cached) return cached;

  cached = new Promise<any>((resolve, reject) => {
    const settle = () =>
      window.TradingView
        ? resolve(window.TradingView)
        : reject(new Error("tv.js loaded without global TradingView"));

    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${TV_SRC}"]`
    );
    if (existing) {
      existing.addEventListener("load", settle);
      existing.addEventListener("error", () => {
        cached = null;
        reject(new Error("tv.js failed to load"));
      });
      if (window.TradingView) settle();
      return;
    }

    const script = document.createElement("script");
    script.src = TV_SRC;
    script.async = true;
    script.onload = settle;
    script.onerror = () => {
      cached = null;
      reject(new Error("tv.js failed to load"));
    };
    document.head.appendChild(script);
  });

  return cached;
}
